import useNotificationStore from "@/stores/notifications";

export type NotificationType = "info" | "success" | "danger" | "loading";

export interface NotificationConfig {
  success?: {
    message: string;
    type?: NotificationType;
  };
  error?: {
    message: string;
    type?: NotificationType;
  };
  loading?: {
    message: string;
    type?: NotificationType;
  };
}

export function useNotifications() {
  const notificationStore = useNotificationStore();

  const showSuccess = (message: string) => {
    return notificationStore.setToast("success", message);
  };

  const showError = (message: string) => {
    return notificationStore.setToast("danger", message);
  };

  const showInfo = (message: string) => {
    return notificationStore.setToast("info", message);
  };

  const showLoading = (message: string) => {
    return notificationStore.setToast("loading", message);
  };

  const clearNotification = (id: string) => {
    notificationStore.clearToast(id);
  };

  return {
    showSuccess,
    showError,
    showInfo,
    showLoading,
    clearNotification,
  };
}
